import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

/**
 * @file 自定义列下拉组件
 * @author alfielv
 */
import _ from 'lodash';
import React, { useCallback, useMemo } from 'react';
import { DropMenu, DropMenuTrigger, Button, Icon } from '@tencent/spaui';
import OptionComponent from './Option';
import { PREFIX_CLS } from '../../../constants';
var prefixCls = "".concat(PREFIX_CLS, "-custom-column__dropmenu"); // dropmenu需要一个组，起个默认组名

var DEAFULT_MENU_GROUP_NAME = 'CUSTOM_COLUMN';
var CustomColumnDropMenu = /*#__PURE__*/React.memo(function (props) {
  var activeConfigureName = props.activeConfigureName,
      originConfigureList = props.originConfigureList,
      dropMenuProps = props.dropMenuProps,
      onDelete = props.onDelete,
      onEdit = props.onEdit,
      onSelect = props.onSelect,
      dropMenuTriggerProps = props.dropMenuTriggerProps,
      dropMenuTriggerComponent = props.dropMenuTriggerComponent; // footer component
  // eslint-disable-next-line @typescript-eslint/naming-convention

  var FooterComponent = useMemo(function () {
    return /*#__PURE__*/React.createElement("div", {
      className: "spaui-submenu-footer ".concat(prefixCls, "__custom-button ").concat(activeConfigureName === 'SESSION_STORAGE' ? 'selected' : ''),
      onClick: function onClick() {
        return onEdit('SESSION_STORAGE');
      }
    }, /*#__PURE__*/React.createElement("span", {
      className: "spaui-text"
    }, "\u81EA\u5B9A\u4E49"));
  }, [onEdit, activeConfigureName]); // 下拉数据

  var dataSource = useMemo(function () {
    return [{
      name: DEAFULT_MENU_GROUP_NAME,
      list: _.map(originConfigureList, function (_ref) {
        var name = _ref.name;
        return {
          label: name,
          value: name
        };
      })
    }];
  }, [originConfigureList]); // 切换下拉选项

  var handleChange = useCallback(function (_event, _value, itemValue) {
    onSelect(itemValue.value);
  }, [onSelect]);
  return /*#__PURE__*/React.createElement(DropMenuTrigger, _extends({
    alignment: "auto",
    dropMenu: /*#__PURE__*/React.createElement(DropMenu, _extends({
      className: "".concat(prefixCls, " with-checkmark"),
      value: _defineProperty({}, DEAFULT_MENU_GROUP_NAME, activeConfigureName),
      data: dataSource,
      onChange: handleChange,
      title: "\u5E38\u7528\u81EA\u5B9A\u4E49\u5217",
      LinkComponent: OptionComponent,
      LinkComponentProps: {
        prefixCls: prefixCls,
        onEdit: onEdit,
        onDelete: onDelete
      },
      postContent: FooterComponent
    }, dropMenuProps))
  }, dropMenuTriggerProps), /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls, "__trigger")
  }, dropMenuTriggerComponent ? dropMenuTriggerComponent : /*#__PURE__*/React.createElement(Button, {
    className: "borderless",
    icon: /*#__PURE__*/React.createElement(Icon, {
      name: "custom-outlined"
    })
  }, "\u81EA\u5B9A\u4E49\u5217")));
});
export default CustomColumnDropMenu;